export default __webpack_public_path__ + "static/media/event.6acf2da6.png";